module.exports = __webpack_public_path__ + "img/mapa-texto.f73a7700.svg";